import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Bs4UxTemplates, getUxTemplate, UxAccordion, useStateUxTemplate } from '../Bs4UxTemplates';
import Bs4I18N from '../../Bs4I18N';

export const TYPE_BS4REPORTCALENDAR = 'type_Bs4ReportCalendar';

export default class Bs4ReportCalendarUx {  

  constructor(optionType, id, optionId) {
    this.optionType = optionType;
    this.id = id;
    this.optionId = optionId;
  }

  getType = () => TYPE_BS4REPORTCALENDAR;

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportGeneric',
    body: {
      Report: {          
      },
    },
  };

  setUxTemplate = ()  => {
    this.uxTemplate = getUxTemplate(this.defaultUxTemplate, this.optionType, this.id, this.optionId);
  }
  
  getUxTemplateEditor = (uxEditor) => {
    return []
  }
  
}